import { Box, Divider, Text } from '@wix/design-system';
import React from 'react';
import { FeatureRow } from './FeatureRow';
const SECTION_DIVIDER_COLOR = {
  '--wds-divider-fill-dark': 'var(--wds-color-text-standard-primary)'
};
export const FeaturesNamespace = _ref => {
  var _namespace$content, _namespace$features;
  let {
    namespace,
    productId,
    t,
    Trans
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    style: SECTION_DIVIDER_COLOR
  }, /*#__PURE__*/React.createElement(Box, {
    paddingTop: "18px",
    paddingBottom: "18px"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "bold"
  }, t(((_namespace$content = namespace.content) == null || (_namespace$content = _namespace$content.name) == null ? void 0 : _namespace$content.translationKey) ?? ''))), /*#__PURE__*/React.createElement(Divider, {
    skin: "dark"
  }), (_namespace$features = namespace.features) == null ? void 0 : _namespace$features.map(feature => /*#__PURE__*/React.createElement(React.Fragment, {
    key: feature.id
  }, /*#__PURE__*/React.createElement(FeatureRow, {
    feature: feature,
    productId: productId,
    t: t,
    Trans: Trans
  }), /*#__PURE__*/React.createElement(Divider, null))));
};
//# sourceMappingURL=FeaturesNamespace.js.map